import { render, staticRenderFns } from "./my-registers-report.vue?vue&type=template&id=299f53e3&lang=pug&"
import script from "./my-registers-report.vue?vue&type=script&lang=ts&"
export * from "./my-registers-report.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports